import type { InputProps as AntInputProps } from "antd";
import { Input as AntInput } from "antd";
import React from "react";
import "../style.scss";
interface CustomInputProps
  extends Omit<
    AntInputProps,
    "onChange" | "onBlur" | "onKeyPress" | "variant" | "id"
  > {
  id?: string | number;
  placeholder?: string;
  type?: string;
  label?: string;
  value?: string | number;
  icon?: React.ReactNode;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  addonAfter?: React.ReactNode;
  className?: string;
  inputClassname?: string;
  labelClass?: string;
  restrictAction?: boolean;
  variant?: "dotted" | "";
  maxLength?: number;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  readOnly?: boolean;
  isDisabled?: boolean;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

function Input({
  id,
  placeholder,
  type = "text",
  label,
  value,
  icon,
  onChange,
  addonAfter,
  className,
  inputClassname,
  labelClass,
  restrictAction,
  variant = "",
  maxLength,
  onBlur,
  readOnly,
  isDisabled,
  onKeyPress,
  ...rest
}: CustomInputProps) {
  return (
    <div className={`flex input flex-col w-full gap-1 ${className ?? ""}`}>
      {label && (
        <label className={`input-label ${labelClass ?? ""}`} htmlFor={id}>
          {label}
        </label>
      )}

      <AntInput
        {...rest}
        disabled={isDisabled}
        readOnly={readOnly}
        maxLength={maxLength}
        type={type}
        className={`${inputClassname ?? ""} ${
          variant === "dotted" ? "dotted-input" : ""
        }`}
        id={id}
        placeholder={placeholder}
        value={value}
        suffix={icon}
        onKeyPress={onKeyPress}
        onChange={onChange}
        onBlur={onBlur}
        addonAfter={addonAfter}
        onCopy={
          restrictAction
            ? (e: { preventDefault: () => any }) => e.preventDefault()
            : undefined
        }
        onPaste={
          restrictAction
            ? (e: { preventDefault: () => any }) => e.preventDefault()
            : undefined
        }
        onCut={
          restrictAction
            ? (e: { preventDefault: () => any }) => e.preventDefault()
            : undefined
        }
      />
    </div>
  );
}

export default Input;
